module.exports = __webpack_public_path__ + "img/apple.a111d976.svg";